import Vue from 'vue'
export default Vue.extend({
  data:() => ({
    screenWidth: window.innerWidth
  }),
  methods: {
    isBarrelSealed(currentStatus: string):boolean{
      return passOrEquivalentStatus(currentStatus,Status.BarrelSealed);
    }
  }
});

/**
 * Determine if the current status is passed  the ```statusToCompare```.
 *
 * @param input current status
 * @param statusToCompare status to compare against
 * @returns
 * ```true``` - if current status is at or pass ```statusToCompare```
 *
 * ```false``` - if NOT at or pass ```statusToCompare```
 */
const passOrEquivalentStatus = (input: string, statusToCompare: string) => {
  return statusOrder[input] >= statusOrder[statusToCompare];
}

export class Status {
  static readonly PaymentPending = 'Payment Pending';
  static readonly ToBeSetup = 'To Be Setup';
  static readonly ReadyForItems = 'Ready For Items';
  static readonly ShipmentRequested = 'Shipment Requested';
  static readonly BarrelSealed = 'Sealed';
  static readonly ShipmentInProgress = 'Shipment In Progress';
  static readonly BarrelCleared = 'Barrel Cleared';
  static readonly ReadyForDelivery = 'Ready For Delivery';
  static readonly DeliveryInProgress = 'Delivery In Progress';
  static readonly DeliveryComplete = 'Delivery Complete';
  static readonly ReadyForPickup = 'Ready For Pickup';
  static readonly PickupComplete = 'Pickup Complete';
}

const statusOrder: {[key:string]: number} = {
  [Status.PaymentPending] : 1,
  [Status.ToBeSetup] : 2,
  [Status.ReadyForItems] : 3,
  [Status.ShipmentRequested] : 4,
  [Status.BarrelSealed] : 5,
  [Status.ShipmentInProgress] : 6,
  [Status.BarrelCleared] : 7,
  [Status.ReadyForPickup] : 8,
  [Status.ReadyForDelivery] : 8,
  [Status.DeliveryInProgress] : 9,
  [Status.PickupComplete] : 10,
  [Status.DeliveryComplete] : 10
}